export const amountOptions = [
  2000,
  3000,
  5000,
  10000,
  30000,
  100000,
];

export const getItems = (t: (key: string) => string) => [
  t('components.chargeModal.refundAvailable'),
  t('components.chargeModal.priorityAccess'),
  t('components.chargeModal.vipSupport')
];